"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("antd/es/date-picker/style/css");

var _datePicker = _interopRequireDefault(require("antd/es/date-picker"));

require("antd/es/input/style/css");

var _input = _interopRequireDefault(require("antd/es/input"));

require("antd/es/button/style/css");

var _button = _interopRequireDefault(require("antd/es/button"));

require("antd/es/select/style/css");

var _select = _interopRequireDefault(require("antd/es/select"));

require("antd/es/modal/style/css");

var _modal = _interopRequireDefault(require("antd/es/modal"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _ = _interopRequireWildcard(require("lodash"));

var _moment = _interopRequireDefault(require("moment"));

var _form = _interopRequireDefault(require("antd/lib/form"));

var selectors = _interopRequireWildcard(require("../../redux/selectors"));

var _announcements = require("../../redux/announcements/announcements.types");

var _FroalaCustomUpload = _interopRequireDefault(require("../activity/FroalaCustomUpload"));

var _Util = require("../util/Util");

var _ActivityTooltip = _interopRequireDefault(require("../activity/ActivityTooltip"));

var _util = require("../../service/util");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const {
  confirm
} = _modal.default;
const {
  Item
} = _form.default;
const {
  Option
} = _select.default;
const defaultState = {
  id: undefined,
  type: 'study',
  typeId: 1,
  title: '',
  body: '',
  effectiveStartDate: new Date(),
  effectiveEndDate: new Date()
};
const itemStyle = {
  marginBottom: '10px',
  marginTop: '10px'
};

class AnnouncementForm extends _react.Component {
  constructor() {
    super(...arguments);
    this.state = _.cloneDeep(defaultState);
    this.form = /*#__PURE__*/_react.default.createRef();

    this.handleSave = e => {
      const {
        id
      } = this.state;

      if (this.form.current) {
        this.form.current.validateFields().then(() => {
          confirm({
            title: `Are you sure you want to ${id ? 'edit' : 'create'} this announcement?`,
            content: '',
            okText: 'Confirm',
            onOk: () => {
              this.handleSaveAnnouncement();
            },

            onCancel() {}

          });
        });
      }
    };

    this.handleSaveAnnouncement = async () => {
      const {
        closeHandler,
        createAnnouncement,
        updateAnnouncement
      } = this.props;
      const {
        id,
        title,
        body,
        type,
        typeId,
        effectiveStartDate,
        effectiveEndDate
      } = this.state;
      const announcement = {
        id,
        title,
        body,
        type,
        typeId,
        effectiveStartDate,
        effectiveEndDate
      };
      announcement.body = (0, _util.cleanstring)(body);

      if (id) {
        updateAnnouncement(announcement);
      } else {
        createAnnouncement(announcement);
      }

      this.resetState();
      closeHandler();
    };

    this.handleCancel = e => {
      const {
        closeHandler
      } = this.props;
      confirm({
        title: 'Are you sure you want to leave this announcement?',
        content: 'You will lose all changes.',
        okText: 'Leave',
        okType: 'danger',
        onOk: () => {
          this.resetState();
          closeHandler();
        },

        onCancel() {}

      });
    };

    this.resetState = () => {
      const resetState = _.cloneDeep(defaultState);

      this.setState(resetState);
    };

    this.onTypeTypeIdChange = value => {
      const typeTypeId = value.split('-');

      if (typeTypeId.length === 2) {
        this.setState({
          type: typeTypeId[0],
          typeId: parseInt(typeTypeId[1])
        });
      }
    };

    this.onTitleChange = e => {
      this.setState({
        title: e.target.value
      });
    };

    this.onBodyChange = value => {
      this.setState({
        body: (0, _Util.updateCmsEditorBeforeSave)(value)
      });
    };

    this.validateBody = (rule, value, cb) => {
      const {
        body
      } = this.state;

      try {
        if (body.length === 0) {
          throw new Error('Body is required.');
        }

        cb();
      } catch (err) {
        cb(err);
      }
    };

    this.onStartDateChange = (date, dateString) => {
      this.setState({
        effectiveStartDate: dateString.length ? dateString : undefined
      });
    };

    this.onEndDateChange = (date, dateString) => {
      this.setState({
        effectiveEndDate: dateString.length ? dateString : undefined
      });
    };

    this.disabledDate = current => {
      return !!(current && current < (0, _moment.default)().startOf('day'));
    };

    this.validateStartDate = (rule, value, cb) => {
      try {
        const {
          effectiveEndDate
        } = this.state;

        if (effectiveEndDate && (0, _moment.default)(value).isSameOrAfter(effectiveEndDate)) {
          throw new Error("An announcement's start date must proceed its end date.");
        }

        cb();
      } catch (err) {
        cb(err);
      }
    };

    this.validateEndDate = (rule, value, cb) => {
      try {
        const {
          effectiveStartDate
        } = this.state;

        if (value && (0, _moment.default)(effectiveStartDate).isSameOrAfter(value)) {
          throw new Error("An announcement's end date must follow its start date.");
        }

        cb();
      } catch (err) {
        cb(err);
      }
    };
  }

  componentDidMount() {
    const {
      announcement,
      studyId
    } = this.props;

    if (announcement && announcement.id) {
      const mergedAnnouncement = _.merge(_.cloneDeep(defaultState), announcement);

      this.setState({ ...mergedAnnouncement
      });
    } else {
      // Default state is set to create an annoucement
      // on the study level.
      const modifiedAnnouncement = _.cloneDeep(this.state);

      modifiedAnnouncement.typeId = studyId;
      this.setState({ ...modifiedAnnouncement
      });
    }
  }

  render() {
    const {
      id,
      type,
      typeId,
      title,
      body,
      effectiveStartDate,
      effectiveEndDate
    } = this.state;
    const {
      visible,
      arms,
      studyId
    } = this.props;
    const footerActions = [/*#__PURE__*/_react.default.createElement(_button.default, {
      type: "primary",
      onClick: this.handleSave,
      key: "btn-save"
    }, "Save"), /*#__PURE__*/_react.default.createElement(_button.default, {
      type: "default",
      onClick: this.handleCancel,
      key: "btn-cancel"
    }, "Cancel")];
    return /*#__PURE__*/_react.default.createElement(_modal.default, {
      title: "Add/Edit Announcement",
      visible: visible,
      onOk: this.handleSave,
      onCancel: this.handleCancel,
      footer: footerActions,
      closable: false,
      destroyOnClose: true,
      width: "50%",
      style: {
        minWidth: '400px'
      }
    }, /*#__PURE__*/_react.default.createElement(_form.default, {
      ref: this.form,
      key: `announcement-form-${id}`,
      layout: "vertical",
      colon: false
    }, /*#__PURE__*/_react.default.createElement(Item, {
      key: `type-${id}`,
      name: "type",
      label: "Type:",
      style: itemStyle,
      rules: [{
        required: true,
        message: 'Type is required.'
      }],
      initialValue: `${type}-${typeId}`
    }, /*#__PURE__*/_react.default.createElement(_select.default, {
      onChange: this.onTypeTypeIdChange,
      style: {
        width: 120
      }
    }, /*#__PURE__*/_react.default.createElement(Option, {
      value: `study-${studyId}`
    }, "Study"), arms && arms.map((arm, index) => {
      return /*#__PURE__*/_react.default.createElement(Option, {
        value: `arm-${arm.id}`,
        key: index
      }, arm.name);
    }))), /*#__PURE__*/_react.default.createElement(Item, {
      key: `title-${id}`,
      name: "title",
      label: "Title:",
      style: itemStyle,
      rules: [{
        required: true,
        message: 'Title is required.'
      }],
      initialValue: title
    }, /*#__PURE__*/_react.default.createElement(_input.default, {
      placeholder: "Title",
      onChange: this.onTitleChange
    })), /*#__PURE__*/_react.default.createElement(Item, {
      key: `body-${id}`,
      name: "body",
      label: "Body:",
      style: itemStyle,
      rules: [{
        required: true,
        validator: this.validateBody
      }],
      valuePropName: "model",
      initialValue: body
    }, /*#__PURE__*/_react.default.createElement(_FroalaCustomUpload.default, {
      onChange: this.onBodyChange
    })), /*#__PURE__*/_react.default.createElement(Item, {
      key: `effectiveStartDate-${id}`,
      name: "effectiveStartDate",
      label: /*#__PURE__*/_react.default.createElement("span", null, "Start Date:", /*#__PURE__*/_react.default.createElement(_ActivityTooltip.default, {
        text: "If no start date is provided this will start now. Otherwise it will start on the hour you specify in the user's local timezone."
      })),
      style: itemStyle,
      rules: [{
        required: false,
        validator: this.validateStartDate
      }],
      validateTrigger: ['onChange'],
      initialValue: effectiveStartDate ? (0, _moment.default)(effectiveStartDate) : undefined
    }, /*#__PURE__*/_react.default.createElement(_datePicker.default, {
      disabledDate: this.disabledDate,
      showTime: true,
      placeholder: "Select start date",
      onChange: this.onStartDateChange,
      format: "YYYY-MM-DD HH:mm"
    })), /*#__PURE__*/_react.default.createElement(Item, {
      key: `effectiveEndDate-${id}`,
      name: "effectiveEndDate",
      label: /*#__PURE__*/_react.default.createElement("span", null, "End Date:", /*#__PURE__*/_react.default.createElement(_ActivityTooltip.default, {
        text: "If no end date is provided, then the announcement will be active until the next announcement start date. Otherwise it will end on the hour you specify in the user's local timezone"
      })),
      style: itemStyle,
      rules: [{
        required: false,
        validator: this.validateEndDate
      }],
      validateTrigger: ['onChange'],
      initialValue: effectiveEndDate ? (0, _moment.default)(effectiveEndDate) : undefined
    }, /*#__PURE__*/_react.default.createElement(_datePicker.default, {
      disabledDate: this.disabledDate,
      showTime: true,
      placeholder: "Select end date",
      onChange: this.onEndDateChange,
      format: "YYYY-MM-DD HH:mm"
    }))));
  }

}

const mapStateToProps = state => {
  return {
    studyId: selectors.getRequestedStudyId(state),
    arms: selectors.getRequestedStudyStudyArms(state)
  };
};

const mapDispatchToProps = dispatch => {
  return {
    createAnnouncement: announcement => dispatch(_announcements.createAnnouncementAsync.request(announcement)),
    updateAnnouncement: announcement => dispatch(_announcements.updateAnnouncementAsync.request(announcement))
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AnnouncementForm);

exports.default = _default;